<template>
    <div id="autocomplete-component">
        <input :id="autocomplete_uid" class="autocomplete-input" />
        <div id="places-service"></div>
    </div>
</template>
<script>
import { uid } from 'uid'

export default {
    name: 'AutocompleteComponent',
    data() {
        return {
            autocomplete_uid: `autocomplete-input-${uid()}`,
            autocomplete: {},
        }
    },
    methods: {
        async getDetails(placeId = '') {
            const PlacesService = new google.maps.places.PlacesService(document.getElementById('places-service'))
            return new Promise(function (resolve, reject) {
                PlacesService.getDetails({ placeId: placeId }, resolve)
            }).catch((error) => {
                this.manageError(error)
            })
        },

        async setDefaultAddress(address, place_id = '') {
            document.getElementById(this.autocomplete_uid).setAttribute('value', address)
            return this.getDetails(place_id).then((place) => {
                if (place) {
                    this.$emit('place_changed', this.autocomplete.getPlace())
                }
            })
        },
    },
    mounted() {
        const input = document.getElementById(this.autocomplete_uid)
        this.autocomplete = new google.maps.places.Autocomplete(input)

        this.autocomplete.addListener('place_changed', () => {
            this.$emit('change:address', this.autocomplete.getPlace())
        })
    },
}
</script>

<style scoped>
.autocomplete-input {
    width: 100%;
    outline: none;
    background: #f0f0f0;
    border-bottom: 2px solid #cccccc;
    margin: 0;

    &:focus {
        border-bottom: 2px solid #1ba0db;
    }
}
</style>
